import type { Segment } from '@hotjar/global-filters/src/domains/global-filters/model/segment';
import type { Store } from '../../../store/list/types';

export const showSaveSegmentModal = (store: Store, segment: Segment): void => {
  const { setEditedSegment } = store.getState();

  setEditedSegment(segment);
};
